import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import axios from "axios";
import { Toaster } from "@/components/ui/sonner";
import { toast } from "sonner";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Wachen from "@/pages/Wachen";
import Zahlungen from "@/pages/Zahlungen";
import Statistiken from "@/pages/Statistiken";
import Feedback from "@/pages/Feedback";
import Einstellungen from "@/pages/Einstellungen";
import GlobalContent from "@/pages/GlobalContent";
import UserDashboard from "@/pages/UserDashboard";
import Layout from "@/components/Layout";
import UserLayout from "@/components/UserLayout";
import PublicContract from "@/pages/PublicContract";
import PublicContractResult from "@/pages/PublicContractResult";
import ContractManage from "@/pages/ContractManage";
import WacheDetail from "@/pages/WacheDetail";
import ContractSettings from "@/pages/ContractSettings";
import TermsChange from "@/pages/TermsChange";
import Netzwerke from "@/pages/Netzwerke";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Set axios default auth header
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 &&
        !error.config?.url?.includes("/api/network/") &&
        !error.config?.url?.endsWith("/api/auth/login")) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

const ProtectedRoute = ({ children, requiredType }) => {
  const token = localStorage.getItem("token");
  const userType = localStorage.getItem("userType");
  
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  
  if (requiredType && userType !== requiredType) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/vertrag/:token" element={<PublicContract />} />
          <Route path="/vertrag/:token/erfolg" element={<PublicContractResult />} />
          <Route path="/vertrag-verwalten/:token" element={<ContractManage />} />
          <Route path="/vertragsaenderung/:token" element={<TermsChange />} />
          
          {/* Admin Routes */}
          <Route
            path="/"
            element={
              <ProtectedRoute requiredType="admin">
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="wachen" element={<Wachen />} />
            <Route path="wachen/:wacheId" element={<WacheDetail />} />
            <Route path="netzwerke" element={<Netzwerke />} />
            <Route path="abteilungen" element={<Navigate to="/wachen" replace />} />
            <Route path="zahlungen" element={<Zahlungen />} />
            <Route path="statistiken" element={<Statistiken />} />
            <Route path="feedback" element={<Feedback />} />
            <Route path="globale-inhalte" element={<GlobalContent />} />
            <Route path="vertrags-einstellungen" element={<ContractSettings />} />
            <Route path="einstellungen" element={<Einstellungen />} />
          </Route>
          
          {/* User Routes */}
          <Route
            path="/user"
            element={
              <ProtectedRoute requiredType="user">
                <UserLayout />
              </ProtectedRoute>
            }
          >
            <Route path="dashboard" element={<UserDashboard />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export { API };
export default App;
